import React from 'react';
import { MapPin, Phone, Clock, Mail } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Contact = () => {
  return (
    <section id="contacto" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block">
            <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Contacto</span>
            <div className="h-1 w-20 bg-teal-500 mt-2 rounded-full mx-auto"></div>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Vení a Visitarnos o Contactanos
          </h2>
          
          <p className="text-lg text-gray-600">
            Estamos acá para ayudarte. Encontrá nuestra ubicación o comunicate con nosotros.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 shadow-lg border border-teal-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Información de Contacto</h3>
              
              <div className="space-y-6">
                {/* Address */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Dirección</h4>
                    <p className="text-gray-600">{businessInfo.address}</p>
                    <p className="text-gray-600">{businessInfo.city}</p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Teléfono / WhatsApp</h4>
                    <a 
                      href={`tel:${businessInfo.phone}`}
                      className="text-teal-600 hover:text-teal-700 font-medium"
                    >
                      {businessInfo.phone}
                    </a>
                  </div>
                </div>

                {/* Hours */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Horario de Atención</h4>
                    <p className="text-gray-600">{businessInfo.hours}</p>
                    <p className="text-sm text-gray-500 mt-1">Domingos cerrado</p>
                  </div>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="mt-8 space-y-3">
                <a
                  href={`https://wa.me/${businessInfo.whatsapp}?text=Hola! Quisiera hacer una consulta.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full px-6 py-4 bg-teal-500 text-white text-center font-semibold rounded-xl hover:bg-teal-600 transition-colors duration-200 shadow-lg"
                >
                  Escribir por WhatsApp
                </a>
                <a
                  href={`tel:${businessInfo.phone}`}
                  className="block w-full px-6 py-4 bg-white text-teal-600 text-center font-semibold rounded-xl hover:bg-teal-50 transition-colors duration-200 border-2 border-teal-500"
                >
                  Llamar Ahora
                </a>
              </div>
            </div>

            {/* Additional Info Card */}
            <div className="bg-gradient-to-br from-rose-50 to-white rounded-2xl p-6 shadow-md border border-rose-100">
              <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <Mail className="w-5 h-5 text-rose-500" />
                ¿Primera Visita?
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Te recomendamos agendar tu turno por WhatsApp para asegurar tu horario preferido. ¡Estamos muy ansiosos por conocer a tu mascota!
              </p>
            </div>
          </div>

          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-2xl h-[500px] lg:h-full">
            <iframe
              src={businessInfo.mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa de ubicación Patas Club"
              className="w-full h-full"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;